export var Scope;
(function (Scope) {
    Scope[Scope["GLOBAL"] = 0] = "GLOBAL";
    Scope[Scope["TENANT"] = 1] = "TENANT";
})(Scope || (Scope = {}));
export const CommonCacheTTLMs = {
    ONE_MINUTE: 60 * 1000,
    TWO_MINUTES: 2 * 60 * 1000,
    FIVE_MINUTES: 5 * 60 * 1000,
    ONE_DAY: 24 * 60 * 60 * 1000,
    ONE_WEEK: 7 * 24 * 60 * 60 * 1000,
    DISABLED: 1
};
//# sourceMappingURL=types.js.map